import React, { Fragment, useRef } from 'react';
import styles from '../../styles.module.scss';
import { useVendorPointSolutionContext } from '../vendor-solution-provider';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import vendorProgramSchema from '../../utils/vendor-program-schema';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { formatDate } from 'app/vendor-point-solutions/utils/helper';

const VendorProgramForm = (props) => {
  const {
    vendorProgram,
    isGroup,
    onSubmitForm,
    onCancelForm,
    loading
  } = props;

  const {
    categories,
    vendorPoints
  } = useVendorPointSolutionContext();

  const formikRef = useRef();

  const handleSubmitForm = values => {
    onSubmitForm(values, vendorProgram);
  };

  const handleCancelForm = () => {
    onCancelForm(vendorProgram);
  };

  const initialValues = vendorProgram
    ? {
      vendorId: get(vendorProgram, 'vendorId'),
      categoryCode: get(vendorProgram, 'categoryCode'),
      effectiveStartDate: formatDate(get(vendorProgram, 'effectiveStartDate')),
      contact: get(vendorProgram, 'contact', ''),
      website: get(vendorProgram, 'website', ''),
      description: get(vendorProgram, 'description', '')
    }
    : {
      vendorId: '',
      categoryCode: '',
      effectiveStartDate: '',
      website: '',
      contact: '',
      description: ''
    };

  return (
    <tr>
      <td colSpan={isGroup ? 8 : 7}>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmitForm}
          innerRef={formikRef}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={vendorProgramSchema}
        >
          {({ values }) => (
            <Form>
              <div className={styles.containerForm}>
                <div className={styles.tableColVendorPoint}>
                  <div className={styles.requiredContainer}>
                    <Field as='select' name='vendorId'>
                      <option key={`vendor-default`} value=''>
                        Select a vendor
                      </option>
                      {vendorPoints.map(({ vendorId, vendorNm }) =>
                        <option key={`vendor-${vendorId}`} value={vendorId}>
                          {vendorNm}
                        </option>
                      )}
                    </Field>
                    <span className={styles.requiredAsterisk}>*</span>
                  </div>
                  <ErrorMessage
                    className={styles.messageError}
                    component='span'
                    name='vendorId'
                  />
                </div>
                <div className={styles.tableColCategory}>
                  <div className={styles.requiredContainer}>
                    <Field as='select' name='categoryCode'>
                      <option key={`category-default`} value=''>
                        Select a category
                      </option>
                      {categories.map(({ masterCodeCd, name }) =>
                        <option key={`category-${masterCodeCd}`} value={masterCodeCd}>
                          {name}
                        </option>
                      )}
                    </Field>
                    <span className={styles.requiredAsterisk}>*</span>
                  </div>
                  <ErrorMessage
                    className={styles.messageError}
                    component='span'
                    name='categoryCode'
                  />
                </div>
                <div className={styles.tableColDate}>
                  <div className={styles.requiredContainer}>
                    <Field type='text' name='effectiveStartDate'>
                      {({ field }) => (
                        <InputMask
                          {...field}
                          mask='99/99/9999'
                          placeholder='mm/dd/yyyy'
                        />
                      )}
                    </Field>
                    <span className={styles.requiredAsterisk}>*</span>
                  </div>
                  <ErrorMessage
                    className={styles.messageError}
                    component='span'
                    name='effectiveStartDate'
                  />
                </div>
                <div className={styles.tableColPhoneNumber}>
                  <Field type='text' name='contact'>
                    {({ field }) => (
                      <InputMask
                        {...field}
                        mask='(999) 999-9999'
                      />
                    )}
                  </Field>
                  <ErrorMessage
                    className={styles.messageError}
                    component='span'
                    name='contact'
                  />
                </div>
                <div className={styles.tableColWebsite}>
                  <Field type='text' name='website' />
                </div>
                <div className={styles.tableColDescription}>
                  <div className={styles.requiredContainer}>
                    <Field
                      as='textarea'
                      name='description'
                      rows={5}
                      maxLength={300}
                    />
                    <span className={styles.requiredAsterisk}>*</span>
                  </div>
                  <span className={styles.maxLength}>
                   {values.description.length === 0 ? 'Max length 300 characters' : `${values.description.length}/300`}
                </span>
                  <ErrorMessage
                    className={styles.messageError}
                    component='span'
                    name='description'
                  />
                </div>
                {isGroup &&
                  <div className={styles.tableColOwner}></div>
                }
                <div className={styles.tableColAction}>
                  <Fragment>
                    <button className='button' type='submit' disabled={loading}>
                      Save
                    </button>
                    <button className='button secondary' type='button' onClick={handleCancelForm}>
                      Cancel
                    </button>
                  </Fragment>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </td>
    </tr>
  );
};

VendorProgramForm.propTypes = {
  isGroup: PropTypes.bool.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  onCancelForm: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default VendorProgramForm;
